
//忠诚度管理-会员权益
import { get, post, postJson, put, deleteApi,imagePost } from '../axios2'

const RESOURCE_BASE_PATH = '/benefit-batch-send';


//创建权益发放任务
export const createTask = p => postJson(`${RESOURCE_BASE_PATH}/task`, p);

// 分页查询权益发放任务列表
export const queryTaskPage = p => get(`${RESOURCE_BASE_PATH}/task/page`, p);

// 上传文件通用接口：1 蕉内-等级图片/文件 2 蕉内-其他图片 4 德佑上传壁纸 5-批量发放权益导入文件
export const uploadFile = (p,type) => imagePost(`/public/upload/file/`+type, p);

// 分页查询发放明细
export const queryRecordPage = p => get(`${RESOURCE_BASE_PATH}/record/page`, p);

// 查询权益任务详情
export const getTaskDetail = p => get(`${RESOURCE_BASE_PATH}/task/${p}`);

// 终止定时发送任务
export const stopTask = p => get(`${RESOURCE_BASE_PATH}/task/stop/${p}`);

// 获取优惠券详情
export const getCouponDetail = couponId => get(`/sellerCouponWrite/external/detailGetByCouponId?couponId=${couponId}`);

//获取外部优惠券(通过putKey)
export const byPutKey = putKey => get(`/sellerCouponWrite/external/get/byPutKey/${putKey}`);
